import React, { useState } from 'react';
import FolderIcon from '@mui/icons-material/Folder';

import { MenuAnchor } from '@paragon/client-tools';
import { LineDirectory } from '@paragon/contract-library';
import { hasSupervisorFeatureFlag } from '@paragon/login-tools';

import { useDirectoryBreadcrumbs } from '../../../selectors/breadcrumbsSelector';
import { useAppSelector } from '../../hooks';
import { Breadcrumbs } from '../Breadcrumbs';
import { DirectoryMenu } from '../menus/DirectoryMenu';
import { BaseCard } from './BaseCard';

export function DirectoryCard(props: { directory: LineDirectory }) {
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const [menuAnchor, setMenuAnchor] = useState<MenuAnchor>(null);

  const breadcrumbs = useDirectoryBreadcrumbs(props.directory.guid);

  return (
    <BaseCard
      title={props.directory.name}
      subheader={breadcrumbs.length >= 2 ? <Breadcrumbs omitSelf disableLinks crumbs={breadcrumbs} /> : undefined}
      avatar={<FolderIcon />}
      linkTo={`/directories/${props.directory.guid}`}
      menu={
        isSupervisor ? (
          <DirectoryMenu directory={props.directory} anchor={menuAnchor} onClose={() => setMenuAnchor(null)} />
        ) : undefined
      }
      onSetMenuAnchor={setMenuAnchor}
    />
  );
}
